<template>
	<div class="impression-tracker" ref="observable">
	</div>
</template>

<script>
export default {
	props: {
		id: {
			type: Number,
			required: true
		},
		category: {
			type: String,
			required: true
		},
		type: {
			type: String,
			required: true
		},
		label: {
			type: String,
			required: true
		},
		once: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
		}
	},
	mounted() {
		this.$logger('Vue/components/impression-tracker/mounted');

		var component = this;

		// Create an Intersection Observer instance
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				component.track();

				if(component.once) {
					observer.disconnect();
				}
			});
		});

		observer.observe(component.$refs.observable);

	},
	methods: {
		track: function() {

			var component = this;
	
			if(typeof gtag == "undefined") {
				component.$logger('Vue/components/impression-tracker/trackImpression/gtag-undefined');
				return false;
			}
			
			var trackingData = {
				impression_category: component.category,
				impression_type: component.type,
				impression_label: component.label,
				impression_id: component.id,
			};

			gtag('event', 'impression', trackingData);
		}
	}
}
</script>

<style scoped>
</style>
